export const BAMBUS_COOKIE_NO_TRACK = 'bmb_notrack';
export const BAMBUS_COOKIE_TRACK_LEVEL = 'bmb_tracklevel';
export const BAMBUS_COOKIE_TRACK_LEVEL_VALUE_REQUIRED = 'required';
export const BAMBUS_COOKIE_TRACK_LEVEL_VALUE_All = 'all';
